import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70d267d4")

_pushScopeId("data-v-70d267d4")
const _hoisted_1 = { class: "new-join-view" }
const _hoisted_2 = { class: "funicebreaker-join-game__wrapper" }
const _hoisted_3 = { class: "funicebreaker-join-game" }
const _hoisted_4 = { class: "funicebreaker-join-game__heading color-white text-shadow" }
const _hoisted_5 = { class: "input-wrapper" }
const _hoisted_6 = {
  class: "color-white",
  for: "name"
}
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = {
  key: 1,
  class: "error"
}
const _hoisted_9 = { class: "input-wrapper" }
const _hoisted_10 = {
  class: "color-white",
  for: "nickname"
}
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = {
  class: "color-white",
  for: "job"
}
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "input-wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "funicebreaker-join-game__avatars"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('joinGame.createProfile')), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, [
            _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.name')) + "*", 1)
          ]),
          _createVNode(_component_Input, {
            id: "name",
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.name.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true),
          (_ctx.nameTaken)
            ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('joinGame.nameTaken')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('newGame.nickname')), 1),
          _createVNode(_component_Input, {
            id: "nickname",
            type: "text",
            modelValue: _ctx.nickname,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.nickname = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.nickname.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('newGame.job')), 1),
          _createVNode(_component_Input, {
            id: "job",
            type: "text",
            modelValue: _ctx.job,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.job = $event)),
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('join', { name: _ctx.name, nickname: _ctx.nickname, job: _ctx.job })), ["enter"]))
          }, null, 8, ["modelValue"]),
          (_ctx.job.length > 20)
            ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 20 })), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", null, [
            _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.chooseAvatar')) + "*", 1)
          ]),
          (_ctx.availableAvatars)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableAvatars, (avatar) => {
                  return (_openBlock(), _createBlock("img", {
                    key: avatar,
                    class: ["funicebreaker-join-game__avatars-item", {
                'funicebreaker-join-game__avatars-item--selected': avatar === _ctx.selectedAvatar?.name
              }],
                    src: require(`@/assets/avatars/${_ctx.avatars.name}/${avatar}.svg`),
                    onClick: ($event: any) => (_ctx.selectedAvatar = { pack: _ctx.avatars.name, name: avatar })
                  }, null, 10, ["src", "onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_BaseButtonWithSpinner, {
          disabled: 
            !_ctx.name || !_ctx.selectedAvatarExistsInAvatars || _ctx.nameTaken || _ctx.someInputTooLong || _ctx.joinLoading
          ,
          loading: _ctx.joinLoading,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('join', { name: _ctx.name, nickname: _ctx.nickname, job: _ctx.job, avatar: _ctx.selectedAvatar })))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('joinGame.button')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ]))
})